import {createReducer} from '@reduxjs/toolkit';
import type {IPerson} from '../../api/domain/channelsuite/user-services/customer-master-data';
import type {IEmployeeBranch} from '../../api/domain/channelsuite/user-services/employee-master-data';
import {fetchCustomerBranchSuccess, fetchUserPersonSuccess} from './customer-master-data-api-actions';

interface IPersonApiState {
    customer?: IPerson;
    customerBranch?: IEmployeeBranch;
}
export type { IPersonApiState };

export const initialState: IPersonApiState = {};

export const customerMasterDataApiReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(fetchUserPersonSuccess, (state, { payload: customer }) => {
            state.customer = customer;
        })
        .addCase(fetchCustomerBranchSuccess, (state, { payload: customerBranch }) => {
            state.customerBranch = customerBranch;
        });
});
